export default class BlockDeals {
    constructor(container, options) {
        const defaultOptions = {
            swiper: '.deals-list-swiper',
            modal: '.deal-modal',
            infoIcon: '.icon-info',
            modalClose: '.icon-modal-close',
        };
        this.options = Object.assign({}, defaultOptions, options);
        
        this.container = document.querySelector(container);
        this.swiperElem = this.container.querySelector(this.options.swiper);
        this.swiper = null;
        this.modals = this.container.querySelectorAll(this.options.modal);
        this.modalCloseIcons = this.container.querySelectorAll(this.options.modalClose);
        this.infoIcons = this.container.querySelectorAll(this.options.infoIcon);
        
        
        this.initSwiper();
        this.setEvents();
    }
    
    setEvents() {
        this.infoIcons.forEach(icon => {
            icon.addEventListener('click', e => {
                e.stopPropagation()
                this.modals.forEach(modal => {
                    if (modal.dataset.modalId === icon.dataset.modalOpen) {
                        modal.classList.add('active')
                    }
                });
            });
        });

        this.modalCloseIcons.forEach(icon => {
            icon.addEventListener('click', e => {
                e.stopPropagation()
                this.modals.forEach(modal => { 
                    modal.classList.remove('active')
                })
            })
        })
        
    }
    
    initSwiper() {
        this.swiper = new Swiper(this.swiperElem, {
            direction: 'horizontal',
            loop: true,
            slidesPerView: 1.15,
            centeredSlides: true,
            spaceBetween: 15,
            grabCursor: true,
            pagination: {
                el: '.block-deals .deals-list-swiper .swiper-pagination',
                clickable: true
            },
            breakpoints: {
                998: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    spaceBetween: 30
                },
                1400: {
                    slidesPerView: 5,
                    centeredSlides: false,
                    spaceBetween: 30
                }
            }
        })
    }
}